import axiosInstance from "../../utils/axiosInstance";
import { getAuthHeaders } from "../../utils/authHeader";

const BASE_URL = "/integration-request";

export const createIntegrationRequest = async (payload) =>
  (
    await axiosInstance.post(
      `${BASE_URL}`,
      payload,
      getAuthHeaders(),
    )
  ).data;